<template>
  <div class="w-100">
    <div class="mt-3 d-flex align-self-start">
      <div
        class="position-relative align-self-center d-flex align-items-center align-self-center"
      >
        <div
          class="circle-number d-flex justify-content-center align-items-center"
          style="z-index: 1"
        >
          <span>{{ number }}</span>
        </div>
      </div>
      <div class="pl-3 d-flex">
        <div class="align-self-start mt-1">
          <h2 class="size-1_4 m-0 pb-1">
            <strong v-text="$ml.get('settings')">Configuração</strong>
          </h2>
          <p class="d-flex align-items-center">
            <span class="align-self-center" v-text="$ml.get('settingsPentest')">
              Configuração do ambiente, ferramentas e escopo para a execução
              segura do Pentest.
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>
    <!-- Período do pentest -->
    <div v-if="!view" class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div class="d-flex flex-column w-100 mr-3">
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24">
            <div class="form-group">
              <label v-text="$ml.get('executionPeriod')"
                >Data de execução</label
              >
              <div  class="d-flex col-24" style="gap: 10px">
                <div class="col-6">
                  <div class="input-group">
                    <b-form-datepicker
                      style="z-index: 1002"
                      class="datepicker m-0 p-0"
                      label-help=""
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      :locale="$ml.get('ln')"
                      today-button
                      reset-button
                      close-button
                      :label-today-button="$ml.get('today')"
                      :label-reset-button="$ml.get('reset')"
                      :label-close-button="$ml.get('exit')"
                      :min="minDateInitialCampaign"
                      v-model="initialDate"
                      :placeholder="$ml.get('start')"
                    >
                    </b-form-datepicker>
                  </div>
                  <div class="mb-2" v-show="error?.initialDate">
                    <label class="lblError" v-text="$ml.get('enterDate')">Informe uma data</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-group">
                    <b-form-datepicker
                      :disabled="initialDate == null"
                      style="z-index: 1002"
                      class="datepicker m-0 p-0"
                      label-help=""
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      :locale="$ml.get('ln')"
                      today-button
                      reset-button
                      close-button
                      :label-today-button="$ml.get('today')"
                      :label-reset-button="$ml.get('reset')"
                      :label-close-button="$ml.get('exit')"
                      :min="initialDate"
                      v-model="finalDate"
                      :placeholder="$ml.get('end')"
                    >
                    </b-form-datepicker>
                  </div>
                  <div class="mb-2" v-show="error?.finalDate">
                    <label class="lblError">Informe uma data</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tipo de pentest -->
    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div class="d-flex flex-column w-100 mr-3">
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24 col-md-17 col-lg-9">
            <div class="form-group">
              <label v-text="$ml.get('pentestType')">Tipo de Pentest</label>
              <div v-if="view" class="d-flex align-items-center disable-custom">
                <svg
                  v-if="selectedPentest.id == 'whitebox'"
                  width="24"
                  height="24"
                  class="ico-view-report"
                >
                  <image
                    xlink:href="../../../assets/icons/whitebox.png"
                    width="24"
                    height="24"
                  />
                </svg>
                <svg v-else width="24" height="24" class="ico-view-report">
                  <image
                    xlink:href="../../../assets/icons/blackbox.png"
                    width="24"
                    height="24"
                  />
                </svg>

                <p class="m-0" style="font-weight: 400">
                  {{ $ml.get(selectedPentest.id) }}
                </p>
              </div>
              <multiselect
                v-else
                style="z-index: 1001"
                v-model="selectedPentest"
                :allow-empty="false"
                label="name"
                :options="optionsPentent"
                :custom-label="nameLang"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :placeholder="$ml.get('program')"
              >
              </multiselect>
            </div>
            <div v-show="selectedPentest.id === 'whitebox'" class="mb-4">
              <div class="alert alert-warning">
                <span v-text="$ml.get('testDataProvided')">Dados fornecidos para a realização dos testes</span>
              </div>
              <div
                v-if="view"
                class="d-flex align-items-center p-0"
                style="gap: 10px"
              >
                <svg v-if="accessCredentials" width="20" height="20">
                  <image
                    xlink:href="../../../assets/icons/check-fill-email.svg"
                    width="20"
                    height="20"
                  />
                </svg>
                <svg v-else width="20" height="20">
                  <image
                    xlink:href="../../../assets/icons/close-fill.svg"
                    width="20"
                    height="20"
                  />
                </svg>
                <strong>{{ $ml.get("credential_access") }}</strong>
              </div>
              <div v-else class="custom-control custom-checkbox mb-2">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="accessCredentials"
                  style="height: 15px; width: 15px"
                />

                <label class="custom-control-label">
                  <strong>{{ $ml.get("credential_access") }}</strong>
                </label>
              </div>
              <div
                v-if="view"
                class="d-flex align-items-center p-0"
                style="gap: 10px"
              >
                <svg v-if="sourceCode" width="20" height="20">
                  <image
                    xlink:href="../../../assets/icons/check-fill-email.svg"
                    width="20"
                    height="20"
                  />
                </svg>
                <svg v-else width="20" height="20">
                  <image
                    xlink:href="../../../assets/icons/close-fill.svg"
                    width="20"
                    height="20"
                  />
                </svg>
                <strong>{{ $ml.get("sourceCode") }}</strong>
              </div>
              <div v-else class="custom-control custom-checkbox">
                <input
                  :disabled="view"
                  type="checkbox"
                  class="custom-control-input"
                  v-model="sourceCode"
                  style="height: 15px; width: 15px"
                />
                <label class="custom-control-label">
                  <strong>{{ $ml.get("sourceCode") }}</strong>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Presencial ou remoto -->
    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div class="d-flex flex-column w-100 mr-3 mb-3">
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24 col-md-17 col-lg-9">
            <div class="form-group">
              <label v-text="$ml.get('applicationLocation')"
                >Local de Aplicação</label
              >
              <div v-if="view" class="disable-custom">
                <span style="font-weight: 400">{{
                  $ml.get(selectedPentestLocation.id)
                }}</span>
              </div>
              <multiselect
                v-else
                style="z-index: 1001"
                v-model="selectedPentestLocation"
                :allow-empty="false"
                label="name"
                :options="optionsPentestLocation"
                :custom-label="nameLang"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :placeholder="$ml.get('selectedLocalApplication')"
              >
              </multiselect>
              <label v-show="error?.errorLocation" class="lblError"
                >{{ $ml.get('selectAnOption') }} *</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Retest -->
    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div class="d-flex flex-column w-100 mr-3 mb-3">
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24 col-md-17 col-lg-9">
            <div class="form-group">
              <label v-text="$ml.get('securityRetest')"
                >Reteste de Segurança</label
              >
              <div
                v-if="view"
                class="d-flex align-items-center p-0"
                style="gap: 10px"
              >
                <svg v-if="retest" width="20" height="20">
                  <image
                    xlink:href="../../../assets/icons/check-fill-email.svg"
                    width="20"
                    height="20"
                  />
                </svg>
                <svg v-else width="20" height="20">
                  <image
                    xlink:href="../../../assets/icons/close-fill.svg"
                    width="20"
                    height="20"
                  />
                </svg>
                <strong>{{ $ml.get("navRetest") }}</strong>
              </div>
              <div v-else class="custom-control custom-checkbox mb-2">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="retest"
                  style="height: 15px; width: 15px"
                />
                <label class="custom-control-label">
                  <strong>{{ $ml.get("navRetest") }}</strong>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Perfil de usuário -->
    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div class="d-flex w-100 mr-3" style="z-index: 0">
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24 col-md-17 col-lg-9">
            <div class="form-group">
              <label>Perfis</label>

              <div
                class="d-flex justify-content-between align-items-center mb-2"
                style="gap: 10px"
                v-if="!view"
              >
                <div class="col-16">
                  <input
                    type="text"
                    class="form-control col"
                    v-model.trim="profile"
                    :placeholder="$ml.get('insertUserProfile')"
                    @input="profileError = false"
                  />
                  <div v-if="error.perfil" class="mb-3">
                    <label class="lblError" v-text="$ml.get('requireAtLeastOneProfile')"
                      >É necessário cadastrar pelo menos um perfil!</label
                    >
                  </div>
                  <div v-if="profileError" class="mb-3">
                    <label class="lblError" v-text="$ml.get('profileAlreadyAdded')"
                      >Este perfil já foi adicionado à lista.</label
                    >
                  </div>
                </div>
                <button
                  style="min-width: 100px"
                  class="btn"
                  v-text="$ml.get('add')"
                  @click.prevent="addPerfil(profile)"
                >
                  Adicionar
                </button>
              </div>
              <div
                v-if="!listProfiles.length"
                class="d-flex justify-content-center"
                style="border-top: 1px solid #cccccc4f; padding: 10px"
              >
                <span style="font-weight: 400" v-text="$ml.get('noProfileAvailable')">Nenhum perfil disponível.</span>
              </div>
              <div
                class="d-flex align-items-center"
                style="flex-wrap: wrap; gap: 10px"
              >
                <div
                  v-show="listProfiles.length"
                  class="mb-2 mt-2 tagsListReport"
                  v-for="(profile, index) in listProfiles"
                  :key="index"
                >
                  <span>{{ profile }}</span>
                  <div @click="removeProfile(index)" class="close">X</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "ConfigPentest",
  props: {
    number: {
      type: String,
      required: true,
    },
    error: {
      type: Object,
      required: false,
    },
    view: {
      type: Boolean,
      required: false,
    },
    dataPentest: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      maxDate: null,
      finalDate: null,

      profile: "",
      profileError: false,
      listProfiles: [],
      sourceCode: false,
      accessCredentials: false,

      initialDate: null,

      selectedPentest: {
        id: "whitebox",
        name: "whitebox",
      },
      optionsPentent: [
        { id: "whitebox", name: "whitebox" },
        { id: "blackbox", name: "blackbox" },
      ],
      retest: false,
      selectedPentestLocation: { id: "remote", name: "remote" },
      optionsPentestLocation: [
        { id: "remote", name: "remote" },
        { id: "in_person", name: "inPerson" },
      ],
    };
  },

  mounted() {
    const type = localStorage.getItem("type_pentest");
    if (!type) return;
    this.getTypePentest(type);
  },
  watch: {
    dataPentest() {
      const {
        initialDate,
        finalDate,
        type,
        profiles,
        reTest,
        sourceCode,
        accessCredentials,
      } = this.dataPentest;
      this.initialDate = initialDate;
      this.listProfiles = profiles;
      this.retest = reTest;
      this.accessCredentials = accessCredentials;
      this.sourceCode = sourceCode;
      this.selectedPentest =
        type === "whitebox"
          ? { id: "whitebox", name: "whitebox" }
          : { id: "blackbox", name: "blackbox" };

      setTimeout(() => {
        this.finalDate = finalDate;
      }, 500);
    },
    initialDate() {
      this.$emit("getInitialDate", this.initialDate);
      this.finalDate = null;
    },
    finalDate() {
      this.$emit("getFinalDate", this.finalDate);
    },
    selectedPentest() {
      this.$emit("getTypePentest", this.selectedPentest.id);
    },
    retest() {
      this.$emit("getRetest", this.retest);
    },
    listProfiles() {
      this.$emit("getListProfile", this.listProfiles);
    },

    accessCredentials() {
      this.$emit("getAccessCredentials", this.accessCredentials);
    },
    sourceCode() {
      this.$emit("getSourceCode", this.sourceCode);
    },
    selectedPentestLocation() {
      this.$emit("getLocation", this.selectedPentestLocation.id);
    },
  },
  computed: {
    minDateInitialCampaign() {
      const now = moment();
      let today = moment(now, "DD/MM/YYYY").format("YYYY-MM-DD");
      return today;
    },
  },
  methods: {
    addPerfil(profile) {
      this.profileError = false;

      if (!profile) return;

      const exists = this.listProfiles.some(
        (p) => p.toLowerCase() === profile.toLowerCase(),
      );

      if (exists) {
        this.profileError = true;
      }

      if (!exists) {
        this.listProfiles.push(profile.toLowerCase());
        this.profile = "";
      }
    },

    removeProfile(index) {
      this.listProfiles.splice(index, 1);
    },
    getTypePentest(type) {
      if (type === "blackbox") {
        this.selectedPentest = {
          id: "blackbox",
          name: "blackbox",
        };

        localStorage.removeItem("type_pentest");
        return;
      }
    },

    nameLang({ name }) {
      return `${this.$ml.get(name)}`;
    },
  },
};
</script>
<style scoped>
.close {
  cursor: pointer;
  color: #8a0ba9;
  font-weight: 500;
  font-size: 0.6rem;
}
.close:hover {
  color: #390546;
}
.disable-custom {
  gap: 10px;
  background: #9e9e9e0a;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #cccccc99;
}
</style>
